import { html, css } from "lit";
import type { TemplateResult } from "lit";
import { customElement } from "lit/decorators.js";
import { localized } from "@lit/localize";

import "@wh-web-front-end/wh-component-library/dist/elements/wh-button";
import "@wh-web-front-end/wh-component-library/dist/elements/wh-icon";

import "../../elements/web-kiosk-back-button";
import "../../elements/web-kiosk-privacy-header";
import "../../elements/web-kiosk-privacy-content";
import { WebKioskPageElement } from "../web-kiosk-page";

declare global {
  interface HTMLElementTagNameMap {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    "web-kiosk-privacy": WebKioskPrivacyElement;
  }
}
@localized()
@customElement("web-kiosk-privacy")
export class WebKioskPrivacyElement extends WebKioskPageElement {
  render(): TemplateResult {
    return html`<section id="privacy">
        <web-kiosk-privacy-header
          .content=${this.content}
        ></web-kiosk-privacy-header>
      </section>
      <web-kiosk-privacy-content
        .content=${this.content}
      ></web-kiosk-privacy-content>`;
  }

  static styles = css`
    #privacy {
      z-index: 0;
    }
  `;
}
